import React from "react";
import PropTypes from "prop-types";
import theme from "../../../themes/themes";
import { Button, Typography, CircularProgress, Box, styled } from "@mui/material";

export default function UploadFileButton({
  id,
  label,
  onChange,
  disabled,
  isLoading,
  size,
  width,
  startIcon
}) {
  const StartIcon = startIcon;

  const FileInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  return (
    <Button
      component="label"
      id={id}
      disabled={disabled}
      sx={{
        width: width,
        minWidth: "32px",
        textTransform: "none",
        borderRadius: "4px",
        color: "black_solid.70",
        backgroundColor: "black_opacity.10",
        border: `1px solid ${theme.palette["black_opacity"]["05"]}`,
        padding: size === "small" ? "2px 4px" : "4px 6px",
        "&:hover": {
          backgroundColor: "white_opacity.100",
          border: `1px solid ${theme.palette["black_opacity"]["40"]}`,
          color: "black_solid.70"
        },
        "&:focus": {
          backgroundColor: "white_opacity.100",
          border: `1px solid ${theme.palette["black_opacity"]["40"]}`,
          color: "black_solid.70"
        },
        "&:active": {
          backgroundColor: "black_opacity.20",
          border: `1px solid ${theme.palette["black_opacity"]["10"]}`,
          color: "black_opacity.100"
        },
        "&:disabled": {
          backgroundColor: "black_opacity.10",
          border: `1px solid ${theme.palette["black_opacity"]["05"]}`,
          color: "black_opacity.30"
        },
      }}
    >
      {isLoading ? (
        <CircularProgress sx={{ color: "black_solid.70" }} size={size === "small" ? 16 : 20} />
      ) : (
        <Box sx={{ display: "inline-flex", alignItems: "center" }}>
          {startIcon && <StartIcon sx={{ fontSize: size === "small" ? "16px" : "20px", ...label && { marginRight: "4px" } }} />}
          <Typography
            variant={size === "small" ? "button2" : "button1"}
          >
            {label}
          </Typography>
          <FileInput type="file" onChange={onChange} />
        </Box>
      )}
    </Button>
  );
}

UploadFileButton.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  size: PropTypes.string,
  width: PropTypes.string,
  startIcon: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func
  ])
};